import * as React from 'react';
import { get } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';
import { required } from '@utils/validators';

import {
  Input,
  InputField,
  AutoComplete,
  AutoCompleteField,
  RemoteAutoCompleteField,
  RemoteAutoComplete
} from '@components/form';
import { ticketType } from '@modules/tickets/_ticketsEnums';

const View: React.SFC<any> = _props => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <h4>Generovat řadu bloků</h4>

      <Row>
        <Col md={12} className="with-right-divider">
          {[
            { name: 'serialNumber', id: 'serialNumber', label: 'Číslo série *', type: 'text' },
            { name: 'letter', id: 'letter', label: 'Písmeno *', type: 'text', validate: [] },
            { name: 'first', id: 'first', label: 'První *' },
            { name: 'count', id: 'count', label: 'Počet *' }
          ].map(field => (
            <Row key={field.name}>
              <Col md={12}>
                <InputField component={Input} type="number" validate={[required]} {...field} />
              </Col>
            </Row>
          ))}
          <Row>
            <Col md={12}>
              <AutoCompleteField
                component={AutoComplete}
                name={'type'}
                id={'type'}
                label={'Typ bloku *'}
                fullWidth={true}
                items={ticketType}
                labelFunction={o => get(o, 'label')}
                valueFunction={o => get(o, 'id')}
                validate={[required]}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <RemoteAutoCompleteField
                component={RemoteAutoComplete}
                name={'employeeId'}
                id={'employeeId'}
                label={'Strážník *'}
                fullWidth={true}
                url="/metropolis/api/hr/employees"
                labelFunction={o => get(o, 'fullName')}
                valueFunction={o => get(o, 'id')}
                validate={[required]}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>
    <Divider />
  </div>
);

export const TicketsGenerateFormBasic = View;



// WEBPACK FOOTER //
// ./src/modules/tickets/TicketsGenerateFormBasic.tsx